// @ts-nocheck
import React, { useState, useEffect } from "react";
import moment from "moment";

const TIME_PATTERN = "HH:mm";

export const CurrentTimeComponent = () => {
  const [currentTime, setCurrentTime] = useState(moment().format(TIME_PATTERN));
  const dayOfWeek = moment().format("dddd");

  const capitalizedDayOfWeek =
    dayOfWeek.charAt(0).toUpperCase() + dayOfWeek.slice(1);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(moment().format(TIME_PATTERN));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <p className={"mb-2 text-sm text-secondary"}>
      {capitalizedDayOfWeek}, {currentTime}
    </p>
  );
};
